<template>
  <div class="m-feed">
    <!-- 骨架屏与真实卡片同构（头像行 / 文字行 / 操作行），
         加载完成时只换内容不换结构，不会出现高度跳变 -->
    <template v-if="loading">
      <div class="m-feed__sk" v-for="i in skeletonCount" :key="'sk-' + i">
        <div class="m-feed__sk-head">
          <span class="m-feed__sk-avatar"></span>
          <span class="m-feed__sk-ident">
            <i class="m-feed__sk-bar" style="width: 38%"></i>
            <i class="m-feed__sk-bar m-feed__sk-bar--sm" style="width: 55%"></i>
          </span>
        </div>
        <i class="m-feed__sk-bar m-feed__sk-bar--text" style="width: 100%"></i>
        <i class="m-feed__sk-bar m-feed__sk-bar--text" style="width: 82%"></i>
        <div class="m-feed__sk-actions">
          <i class="m-feed__sk-bar" v-for="n in 3" :key="n" style="width: 34px"></i>
        </div>
      </div>
    </template>

    <template v-else>
      <!-- index 传下去给 MobileFeedItem 判断头像是否属于首屏（首屏头像不懒加载） -->
      <MobileFeedItem
        v-for="(item, index) in list"
        :key="item.id"
        :item="item"
        :index="index"
      />
    </template>
  </div>
</template>

<script>
import MobileFeedItem from './MobileFeedItem.vue'

export default {
  name: 'MobileFeed',
  components: { MobileFeedItem },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    // 是否展示骨架屏
    loading: {
      type: Boolean,
      default: false
    },
    // 骨架屏卡片数量
    skeletonCount: {
      type: Number,
      default: 5
    }
  }
}
</script>

<style scoped lang="scss">
// 列表容器：左右留出安全边距，卡片之间用页面底色分隔
.m-feed {
  width: 100%;
  padding: 0 8px;
  box-sizing: border-box;

  // 卡片之间的间距由卡片自己的 margin-bottom 负责（见 MobileFeedItem.vue），
  // 骨架屏保持同样的节奏，加载完成时不会出现位移。
  &__sk {
    padding: 14px 12px 12px;
    margin-bottom: 8px;
    background: var(--background-color, #fff);
    border-radius: 12px;
  }

  &__sk-head {
    display: flex;
    align-items: center;
    margin-bottom: 12px;
  }

  &__sk-avatar {
    width: 38px;
    height: 38px;
    margin-right: 10px;
    border-radius: 50%;
    background: #f0f1f3;
    flex-shrink: 0;
  }

  &__sk-ident {
    flex: 1;
    min-width: 0;
  }

  &__sk-bar {
    display: block;
    height: 12px;
    border-radius: 6px;
    background: #f0f1f3;

    &--sm {
      height: 10px;
      margin-top: 6px;
    }

    &--text {
      height: 14px;
      margin-bottom: 8px;
    }
  }

  &__sk-actions {
    display: flex;
    gap: 60px;
    margin-top: 14px;
  }

  &__sk-avatar,
  &__sk-bar {
    animation: m-feed-breath 1.6s ease-in-out infinite;
  }
}

@keyframes m-feed-breath {
  0% { opacity: 0.65; }
  50% { opacity: 1; }
  100% { opacity: 0.65; }
}
</style>
